module.exports = __webpack_public_path__ + "img/benoit16.62743099.jpg";